// extracted by mini-css-extract-plugin
export default {"markdownFormatter":"MarkDownFormatter_markdownFormatter__2MDKr"};